import { render, staticRenderFns } from "./Bala.vue?vue&type=template&id=1b436c72&"
import script from "./Bala.vue?vue&type=script&lang=ts&"
export * from "./Bala.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports